import { render, staticRenderFns } from "./LightedCanvas.vue?vue&type=template&id=24ff1920&"
import script from "./LightedCanvas.vue?vue&type=script&lang=js&"
export * from "./LightedCanvas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports